import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=21cc43ca&scoped=true&"
import script from "./ActivityInfo.vue?vue&type=script&lang=js&"
export * from "./ActivityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=21cc43ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc43ca",
  null
  
)

export default component.exports